export default __webpack_public_path__ + "static/media/website.25a275a1.png";